import { useMemo } from 'react';
import type { SensorAPI } from 'react-beautiful-dnd';
import { useMouseSensor, useKeyboardSensor, useTouchSensor } from 'react-beautiful-dnd';

function createOverrideApi(api: SensorAPI) {
  // Prevents react-dnd-beautiful drags when an element between the target and the draggable contains the 'data-disable-drag' property
  return {
    ...api,
    findClosestDraggableId: (event: Event) => {
      const closestDraggableId = api.findClosestDraggableId(event);
      if (closestDraggableId === null) return null;

      const targetElement = event.target as HTMLElement;
      const isDragDisabled =
        targetElement.closest(
          `[data-rbd-drag-handle-draggable-id="${closestDraggableId}"] :is([data-disable-drag="true"], [role="option"], [role="combobox"], [role="button"], [role="checkbox"], [role="radio"], button, input, label)`,
        ) !== null;
      return isDragDisabled ? null : closestDraggableId;
    },
  };
}

const useModifiedKeyboardSensor = (api: SensorAPI): void => {
  const overrideApi = useMemo(() => createOverrideApi(api), [api]);
  useKeyboardSensor(overrideApi);
};

const useModifiedMouseSensor = (api: SensorAPI): void => {
  const overrideApi = useMemo(() => createOverrideApi(api), [api]);
  useMouseSensor(overrideApi);
};

const useModifiedTouchSensor = (api: SensorAPI): void => {
  const overrideApi = useMemo(() => createOverrideApi(api), [api]);
  useTouchSensor(overrideApi);
};

export const customSensors = [
  useModifiedMouseSensor,
  useModifiedKeyboardSensor,
  useModifiedTouchSensor,
];
